import { ReactNode, useEffect, useState } from "react";

import { X } from "@hagerty/icons";
import { DialogContent, DialogOverlay } from "@reach/dialog";

import styles from "./DialogV2.module.scss";

type DialogPropsV2 = {
  children: ReactNode;
  heading: string;
  message: string;
  showCloseButton?: boolean;
  delayPopup?: boolean;
  onDismiss?: () => void;
};

export const DialogV2 = ({
  children,
  heading,
  message,
  onDismiss,
  showCloseButton,
  delayPopup = false,
}: DialogPropsV2) => {
  const [visible, setVisible] = useState(!delayPopup);

  // Delay dialog from rendering without getting rid of the background overlay.
  // This is useful for transitioning from one dialog to another.
  useEffect(() => {
    setTimeout(() => {
      if (!visible) {
        setVisible(true);
      }
    }, 200);
  }, [setVisible]);

  return (
    <DialogOverlay className={styles.overlay} onDismiss={onDismiss}>
      {visible && (
        <DialogContent
          role="alert"
          aria-label="dialog content"
          className={styles.dialog}
        >
          <div className={styles.body}>
            <div className={styles.heading}>{heading}</div>
            <div className={styles.message}>{message}</div>
            {children}
          </div>
          {showCloseButton && (
            <button
              className={styles.closeButton}
              type="button"
              aria-label="close dialog"
              onClick={onDismiss}
            >
              <X focusable="false" aria-hidden="true" />
            </button>
          )}
        </DialogContent>
      )}
    </DialogOverlay>
  );
};
